import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";

// Kuitwa kwa PageHero Component
import PageHero from "./PageHero";

// Kuimport picha za sehemu kuu mbili na background ya Hero
import servicesHeroBg from "../assets/image7.jpeg";
import loansSectionImg from "../assets/banner8.png"; /* Picha inayowakilisha Mikopo */
import savingsSectionImg from "../assets/image9.jpeg"; /* Picha inayowakilisha Akiba, Hisa & Amana */

import {
  FaArrowRight,
  FaCheckCircle,
  FaCoins,
  FaHandHoldingUsd,
} from "react-icons/fa";

export default function ServicesLanding(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    // Initializations kama zipo
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  // Hapa tuna kazi ya kushughulikia uratibu wa kubonyeza vitufe kwenda kurasa za ndani
  const handleNavigation = (item, subItem) => {
    appContext.navTo({item, subItem});
  };

  if (ready) {
    return (
      <div className="ycsc-services-landing-page animate__animated animate__fadeIn">
        {/* 2. MAIN INTRO SECTION */}
        <section className="py-5 bg-white text-center">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 col-md-10">
                <span className="premium-accent-kicker">Mshikamano Daima</span>
                <h2 className="premium-section-title mt-2">
                  Ufumbuzi Salama wa Fedha
                </h2>
                <p className="premium-section-subtitle mx-auto">
                  Chagua huduma inayokidhi malengo yako ya sasa na ya baadae.
                  Tunajenga daraja la uhakika kuelekea uhuru wako wa kiuchumi
                  kupitia mifumo rafiki na ya uwazi.
                </p>
                <div className="section-title-separator mx-auto"></div>
              </div>
            </div>
          </div>
        </section>

        {/* 3. DUAL STRATEGIC PILLARS SECTION */}
        <section className="py-5 bg-light-surface">
          <div className="container">
            <div className="row g-5">
              {/* PILLAR 1: MIKOPO YETU */}
              <div className="col-12 col-lg-6">
                <div className="premium-pillar-card shadow-sm h-100">
                  <div className="pillar-image-container">
                    <img
                      src={loansSectionImg}
                      alt="Mikopo Yetu YCSC"
                      className="img-fluid pillar-img"
                    />
                    <div className="pillar-icon-badge">
                      <FaHandHoldingUsd />
                    </div>
                  </div>
                  <div className="pillar-content-body p-4 p-md-5">
                    <h3 className="pillar-heading mb-3">1. Mikopo Yetu</h3>
                    <p className="pillar-description text-muted mb-4">
                      Tunatoa mikopo nafuu yenye viwango vidogo vya riba na
                      masharti rafiki yaliyoundwa kumsaidia mwanachama kukua
                      kiuchumi na kukabiliana na dharura bila shinikizo.
                    </p>

                    <div className="pillar-highlights-box mb-4">
                      <h5 className="highlight-title fw-bold text-dark mb-3">
                        Aina Kuu za Mikopo:
                      </h5>
                      <div className="d-flex align-items-start mb-3">
                        <FaCheckCircle className="text-success mt-1 me-3 flex-shrink-0" />
                        <div>
                          <strong className="d-block text-dark">
                            Mikopo ya Maendeleo & Biashara
                          </strong>
                          <span className="small text-muted">
                            Maalum kwa ajili ya kupanua miradi, uwekezaji wa
                            muda mrefu, ujenzi na kilimo chenye tija.
                          </span>
                        </div>
                      </div>
                      <div className="d-flex align-items-start">
                        <FaCheckCircle className="text-success mt-1 me-3 flex-shrink-0" />
                        <div>
                          <strong className="d-block text-dark">
                            Mikopo ya Dharura & Jamii
                          </strong>
                          <span className="small text-muted">
                            Inapatikana kwa haraka sana ili kutatua changamoto
                            za ghafla kama matibabu, ada za shule na majanga.
                          </span>
                        </div>
                      </div>
                    </div>

                    <button
                      onClick={() => handleNavigation("services", "loans")}
                      className="btn btn-premium-primary w-100 d-flex align-items-center justify-content-center gap-2 py-3 fw-bold"
                    >
                      Fahamu Zaidi Kuhusu Mikopo{" "}
                      <FaArrowRight className="arrow-icon" />
                    </button>
                  </div>
                </div>
              </div>

              {/* PILLAR 2: HISA, AKIBA & AMANA */}
              <div className="col-12 col-lg-6">
                <div className="premium-pillar-card shadow-sm h-100">
                  <div className="pillar-image-container">
                    <img
                      src={savingsSectionImg}
                      alt="Hisa, Akiba na Amana YCSC"
                      className="img-fluid pillar-img"
                    />
                    <div className="pillar-icon-badge bg-secondary-accent">
                      <FaCoins />
                    </div>
                  </div>
                  <div className="pillar-content-body p-4 p-md-5">
                    <h3 className="pillar-heading mb-3">
                      2. Hisa, Akiba & Amana
                    </h3>
                    <p className="pillar-description text-muted mb-4">
                      Huu ndio msingi wa ukwasi wako na umiliki ndani ya SACCOS.
                      Kujiwekea akiba na kuwekeza kwenye chama kunakuhakikishia
                      usalama wa kifedha na faida endelevu.
                    </p>

                    <div className="pillar-highlights-box mb-4">
                      <h5 className="highlight-title fw-bold text-dark mb-3">
                        Nguzo Zetu za Mitaji:
                      </h5>
                      <div className="row g-3">
                        <div className="col-12">
                          <div className="mini-feature-item p-2 rounded border-start border-3 border-primary bg-white">
                            <strong className="text-dark d-block">
                              Hisa za Ushirika
                            </strong>
                            <span className="small text-muted">
                              Uthibitisho wa umiliki wa chama unaokupa haki ya
                              kupiga kura na kupata mgao wa faida kila mwaka.
                            </span>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="mini-feature-item p-2 rounded border-start border-3 border-warning bg-white">
                            <strong className="text-dark d-block">
                              Akiba ya Kila Mwezi
                            </strong>
                            <span className="small text-muted">
                              Akiba ya kudumu inayojenga sifa yako ya
                              kukopesheka na kukuwezesha kupata dhamana ya
                              mikopo.
                            </span>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="mini-feature-item p-2 rounded border-start border-3 border-success bg-white">
                            <strong className="text-dark d-block">
                              Amana Maalum (Deposits)
                            </strong>
                            <span className="small text-muted">
                              Amana za muda maalum kwa ajili ya uwekezaji wa
                              malengo binafsi au dharura za baadae.
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <button
                      onClick={() =>
                        handleNavigation("services", "savings_deposits")
                      }
                      className="btn btn-premium-secondary w-100 d-flex align-items-center justify-content-center gap-2 py-3 fw-bold"
                    >
                      Fahamu Zaidi Kuhusu Akiba & Amana{" "}
                      <FaArrowRight className="arrow-icon" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  } else {
    return (
      <div className="container mSupportLoading py-5 text-center">
        {getInlineLoader()}
      </div>
    );
  }
}
